import { render } from "./CommonTab.vue?vue&type=template&id=2979041a&scoped=true"
import script from "./CommonTab.vue?vue&type=script&lang=js"
export * from "./CommonTab.vue?vue&type=script&lang=js"

import "./CommonTab.vue?vue&type=style&index=0&id=2979041a&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2979041a"]])

export default __exports__